<template>
  <el-dialog
    title="题目关联"
    width="500px"
    :visible="true"
    :before-close="handleClose">
    <div class="dialog-content">
      <div class="field-item">
        <div class="label">当前题目：</div>
        <div class="content">{{ relevance.fieldName }}</div>
      </div>
      <div class="field-item">
        <div class="label">关联题目：</div>
        <div class="content">
          <el-select v-model="value" placeholder="请选择" value-key="flag" >
            <el-option
              v-for="item in relevanceList"
              :key="item.flag"
              :label="item.fieldName"
              :value="item">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="field-item" v-if="value.flag">
        <div class="label"></div>
        <div class="content">
          <span class="text">当关联题目选择下面的选项：</span>
          <el-checkbox-group v-model="checkList">
            <el-checkbox
              v-for="opt in value.selectTypes"
              :key="opt"
              :label="opt"
            ></el-checkbox>
          </el-checkbox-group>
          <span class="text">中的任意一个时，当前题目才会出现</span>
        </div>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="handleConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: "RelevanceDialog",
  props: ["relevanceList", "relevance"],
  data() {
    return {
      value: {},
      checkList: []
    }
  },
  created() {
    console.log(this.relevance);
    console.log(this.relevanceList);
    if (this.relevance.refFieldFlag) {
      // 已关联上
      this.checkList = [...this.relevance.refFieldValue];
      this.value = this.relevanceList.filter(item => item.flag === this.relevance.refFieldFlag)[0] || {};
    }
  },
  methods: {
    handleClose() {
      this.$emit("handleClose");
    },
    handleConfirm() {
      if (!this.checkList.length) {
        this.$notify.warning("请选择选项");
        return;
      }
      const datas = {
        flag: this.value.flag,
        value: this.checkList
      }
      this.$emit("handleConfirm", datas);
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .el-dialog__header {
  padding: 15px;
  border-bottom: 1px solid #ccc;
}
/deep/ .el-dialog__body {
  padding: 15px;
}
.dialog-content {
  min-height: 200px;
  max-height: 500px;
}
.field-item {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  .label {
    width: 80px;
    font-weight: 600;
  }
  .content {
    font-weight: 600;
    .text {
      display: inline-block;
      &:first-child {
        padding-bottom: 20px;
      }
      &:last-child {
        padding-top: 20px;
      }
    }
  }
}
</style>